import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "modal-container show" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "blocker" }, null, -1)
const _hoisted_3 = {
  class: "modal download",
  style: {"width":"500px"}
}
const _hoisted_4 = { class: "modal__content" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "download--header" }, "Download Format?", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "text--align-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-download download--icon" })
], -1)
const _hoisted_7 = { class: "btn--group justify--center pa-1 ma--top-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("a", {
          class: "fa fa-times modal__header--clear float--right",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        }),
        _hoisted_5,
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            class: "btn btn--teal ma--x-1",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.download('csv')))
          }, "CSV"),
          _createElementVNode("button", {
            class: "btn btn--teal ma--x-1",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.download('pdf')))
          }, "PDF"),
          _createElementVNode("button", {
            class: "btn btn--teal ma--x-1",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.download('xlsx')))
          }, "XLSX")
        ])
      ])
    ])
  ]))
}